import { render, staticRenderFns } from "./VueRecapchaBusiness.vue?vue&type=template&id=4008407f&"
import script from "./VueRecapchaBusiness.vue?vue&type=script&lang=js&"
export * from "./VueRecapchaBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports